import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _bulkUpdateOrdersRequest = { fields: 'google.protobuf.FieldMask' };
var _bulkUpdateOrdersResponse = { orders: '_order' };
var _cancelReservationRequest = {};
var _cancelReservationResponse = {};
var _captureAuthorizedPaymentRequest = {};
var _captureAuthorizedPaymentResponse = {};
var _checkIn = { created: 'google.protobuf.Timestamp' };
var _checkoutRequest = {
    overrideRequestTime: 'google.protobuf.Timestamp',
    guests: '_guest',
};
var _checkoutResponse = {
    expires: 'google.protobuf.Timestamp',
    order: '_order',
    reservations: '_ticketReservation',
};
var _confirmOrderRequest = {};
var _confirmOrderResponse = { orders: '_order' };
var _createReservationRequest = {
    overrideRequestTime: 'google.protobuf.Timestamp',
};
var _createReservationResponse = {
    expires: 'google.protobuf.Timestamp',
    reservations: '_ticketReservation',
};
var _formattedAddress = { address: '_address' };
var _formResponse = { inputValues: '_inputValue' };
var _getCheckoutOptionsRequest = {};
var _getCheckoutOptionsResponse = {};
var _getInvoicePreviewRequest = {};
var _getInvoiceRequest = {};
var _getInvoiceResponse = {
    expires: 'google.protobuf.Timestamp',
    reservations: '_ticketReservation',
};
var _getOrderRequest = {};
var _getOrderResponse = { order: '_order' };
var _getSummaryRequest = {};
var _getSummaryResponse = {};
var _guest = { form: '_formResponse' };
var _guestDetails = { form: '_formResponse' };
var _inputValue = {
    number: 'google.protobuf.DoubleValue',
    dateTime: 'google.protobuf.Timestamp',
    address: '_formattedAddress',
};
var _listAvailableTicketsRequest = {
    overrideRequestTime: 'google.protobuf.Timestamp',
};
var _listAvailableTicketsResponse = { definitions: '_ticketDefinition' };
var _listOrdersRequest = {};
var _listOrdersResponse = { orders: '_order' };
var _order = {
    created: 'google.protobuf.Timestamp',
    updated: 'google.protobuf.Timestamp',
    checkoutForm: '_formResponse',
    tickets: '_ticketingTicket',
    paymentDetails: '_paymentDetails',
};
var _paymentDetails = { transaction: '_paymentTransaction' };
var _paymentTransaction = {
    scheduledActionExecutionDate: 'google.protobuf.Timestamp',
};
var _posCheckoutRequest = {};
var _posCheckoutResponse = {
    expires: 'google.protobuf.Timestamp',
    order: '_order',
    reservations: '_ticketReservation',
};
var _queryAvailableTicketsRequest = {};
var _queryAvailableTicketsResponse = { definitions: '_ticketDefinition' };
var _rawHttpResponse = { body: 'BYTES' };
var _ticketDefinition = { salePeriod: '_ticketSalePeriod' };
var _ticketingTicket = { checkIn: '_checkIn', guestDetails: '_guestDetails' };
var _ticketReservation = { ticket: '_ticketDefinition' };
var _ticketSalePeriod = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _updateCheckoutRequest = { guests: '_guest' };
var _updateCheckoutResponse = { order: '_order' };
var _updateOrderRequest = {
    fields: 'google.protobuf.FieldMask',
    expires: 'google.protobuf.Timestamp',
    checkoutForm: '_formResponse',
};
var _updateOrderResponse = { order: '_order' };
var _voidAuthorizedPaymentRequest = {};
var _voidAuthorizedPaymentResponse = {};
function resolveWixEventsTicketingCheckoutServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy',
                destPath: '/api',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        _: [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definition',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/events-ticketing-v1-proxy/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v2/ticket-definitions',
                destPath: '/v2/ticket-definitions',
            },
            {
                srcPath: '/_api/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/events/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/events/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/events/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1/checkout',
                destPath: '/v1/checkout',
            },
            {
                srcPath: '/_api/wix-events-web/v1/ticket-definitions',
                destPath: '/v1/ticket-definitions',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets/available',
                destPath: '/v1/tickets/available',
            },
            {
                srcPath: '/_api/wix-events-web/v1/pos-checkout',
                destPath: '/v1/pos-checkout',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsTicketingOrderManagementUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/viewEvent',
                destPath: '/viewEvent',
            },
            {
                srcPath: '/viewRsvpDashboard',
                destPath: '/viewRsvpDashboard',
            },
            {
                srcPath: '/viewOrderDashboard',
                destPath: '/viewOrderDashboard',
            },
            {
                srcPath: '/viewSummarySubscription',
                destPath: '/viewSummarySubscription',
            },
            {
                srcPath: '/check-in',
                destPath: '/check-in',
            },
            {
                srcPath: '/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/export',
                destPath: '/export',
            },
            {
                srcPath: '/tickets',
                destPath: '/tickets',
            },
            {
                srcPath: '/payment-redirect',
                destPath: '/payment-redirect',
            },
            {
                srcPath: '/admin',
                destPath: '/admin',
            },
            {
                srcPath: '/ticket',
                destPath: '/ticket',
            },
            {
                srcPath: '/media',
                destPath: '/media',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/events/v1/reports',
                destPath: '/v1/reports',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/web',
                destPath: '/v1/web',
            },
            {
                srcPath: '/events/v2/tickets',
                destPath: '/v2/tickets',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of orders, including ticket data, with basic filter support. */
export function listOrders(payload) {
    var _a = serializer(_listOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOrdersResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __listOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.OrderManagement.ListOrders',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/orders',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOrders.fromReq = fromReq;
    __listOrders.__isAmbassador = true;
    return __listOrders;
}
/** Retrieves an order, including ticket data. */
export function getOrder(payload) {
    var _a = serializer(_getOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOrderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __getOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.OrderManagement.GetOrder',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/{eventId}/orders/{orderNumber}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOrder.fromReq = fromReq;
    __getOrder.__isAmbassador = true;
    return __getOrder;
}
/** Updates an order's `checkoutForm` and/or `archived` status. */
export function updateOrder(payload) {
    var _a = serializer(_updateOrderRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOrderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __updateOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.OrderManagement.UpdateOrder',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/{eventId}/orders/{orderNumber}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOrder.fromReq = fromReq;
    __updateOrder.__isAmbassador = true;
    return __updateOrder;
}
/** Updates multiple orders' `"archived"` status. */
export function bulkUpdateOrders(payload) {
    var _a = serializer(_bulkUpdateOrdersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateOrdersResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __bulkUpdateOrders(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.OrderManagement.BulkUpdateOrders',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/{eventId}/orders',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateOrders.fromReq = fromReq;
    __bulkUpdateOrders.__isAmbassador = true;
    return __bulkUpdateOrders;
}
/**
 * Confirms an order.
 *
 * Changes an order's `status` from `"INITIATED"`, `"PENDING"`, or `"OFFLINE_PENDING"` to `"PAID"`.
 *
 * Previously confirmed orders, with a `status` of `"PAID"` or `"FREE"` aren't changed with this method.
 *
 * Confirming orders with the `status` of `"INITIATED"` or `"PENDING"`, triggers an email containing the tickets to the buyer (and to additional guests, if specified).
 */
export function confirmOrder(payload) {
    var _a = serializer(_confirmOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_confirmOrderResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __confirmOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.OrderManagement.ConfirmOrder',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/{eventId}/orders/confirm',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __confirmOrder.fromReq = fromReq;
    __confirmOrder.__isAmbassador = true;
    return __confirmOrder;
}
/** Retrieves a summary of total ticket sales. */
export function getSummary(payload) {
    var _a = serializer(_getSummaryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSummaryResponse, {}).fromJSON;
    function __getSummary(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.OrderManagement.GetSummary',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/orders/summary',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSummary.fromReq = fromReq;
    __getSummary.__isAmbassador = true;
    return __getSummary;
}
/** Returns invoice preview. Works only for PAID orders. */
export function getInvoicePreview(payload) {
    var _a = serializer(_getInvoicePreviewRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __getInvoicePreview(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.OrderManagement.GetInvoicePreview',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/{eventId}/orders/{orderNumber}/invoice',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvoicePreview.fromReq = fromReq;
    __getInvoicePreview.__isAmbassador = true;
    return __getInvoicePreview;
}
/**
 * Captures authorized payment asynchronously.
 * Eventually order will become paid.
 * For orders with non-authorized payments request will fail.
 */
export function captureAuthorizedPayment(payload) {
    var _a = serializer(_captureAuthorizedPaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_captureAuthorizedPaymentResponse, {}).fromJSON;
    function __captureAuthorizedPayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.OrderManagement.CaptureAuthorizedPayment',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/orders/{orderNumber}/capture',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __captureAuthorizedPayment.fromReq = fromReq;
    __captureAuthorizedPayment.__isAmbassador = true;
    return __captureAuthorizedPayment;
}
/**
 * Voids authorized payment asynchronously.
 * Eventually order will become voided.
 * For orders with non-authorized payments request will fail.
 */
export function voidAuthorizedPayment(payload) {
    var _a = serializer(_voidAuthorizedPaymentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_voidAuthorizedPaymentResponse, {}).fromJSON;
    function __voidAuthorizedPayment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.OrderManagement.VoidAuthorizedPayment',
            url: resolveWixEventsTicketingOrderManagementUrl({
                protoPath: '/v1/events/orders/{orderNumber}/void',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __voidAuthorizedPayment.fromReq = fromReq;
    __voidAuthorizedPayment.__isAmbassador = true;
    return __voidAuthorizedPayment;
}
/** Retrieves checkout details. */
export function getCheckoutOptions(payload) {
    var _a = serializer(_getCheckoutOptionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutOptionsResponse, {}).fromJSON;
    function __getCheckoutOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.CheckoutService.GetCheckoutOptions',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/options',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckoutOptions.fromReq = fromReq;
    __getCheckoutOptions.__isAmbassador = true;
    return __getCheckoutOptions;
}
/** Retrieves tickets available to reserve. */
export function listAvailableTickets(payload) {
    var _a = serializer(_listAvailableTicketsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailableTicketsResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __listAvailableTickets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'GET',
            methodFqn: 'wix.events.ticketing.CheckoutService.ListAvailableTickets',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/available-tickets',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailableTickets.fromReq = fromReq;
    __listAvailableTickets.__isAmbassador = true;
    return __listAvailableTickets;
}
/** Retrieves tickets available to reserve. */
export function queryAvailableTickets(payload) {
    var _a = serializer(_queryAvailableTicketsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAvailableTicketsResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __queryAvailableTickets(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.CheckoutService.QueryAvailableTickets',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/available-tickets/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAvailableTickets.fromReq = fromReq;
    __queryAvailableTickets.__isAmbassador = true;
    return __queryAvailableTickets;
}
/**
 * Reserves tickets for 20 minutes.
 *
 * Reserved tickets are deducted from ticket stock and can't be bought by another site visitor.
 * When the reservation expires, the tickets are added back to the stock.
 */
export function createReservation(payload) {
    var _a = serializer(_createReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createReservationResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketReservation: _ticketReservation,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __createReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.CheckoutService.CreateReservation',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/reservations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createReservation.fromReq = fromReq;
    __createReservation.__isAmbassador = true;
    return __createReservation;
}
/** Cancels ticket reservation and returns tickets to stock. */
export function cancelReservation(payload) {
    var _a = serializer(_cancelReservationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelReservationResponse, {}).fromJSON;
    function __cancelReservation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketing.CheckoutService.CancelReservation',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/reservations/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelReservation.fromReq = fromReq;
    __cancelReservation.__isAmbassador = true;
    return __cancelReservation;
}
/** Generates a preview of a reservation invoice, including the specified coupon or pricing plan. */
export function getInvoice(payload) {
    var _a = serializer(_getInvoiceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInvoiceResponse, {
        _ticketDefinition: _ticketDefinition,
        _ticketReservation: _ticketReservation,
        _ticketSalePeriod: _ticketSalePeriod,
    }).fromJSON;
    function __getInvoice(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.CheckoutService.GetInvoice',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/invoices/{reservationId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvoice.fromReq = fromReq;
    __getInvoice.__isAmbassador = true;
    return __getInvoice;
}
/**
 * Checks out the reserved tickets.
 *
 * Creates an order and associates it with a site contact. Guest details are received from the
 * registration form input fields. See the Forms API for details.
 *
 * To change an existing order's `status` from `"INITIATED"`, `"PENDING"`, or `"OFFLINE_PENDING"` to `"PAID"`, call Confirm Order.
 *
 * You can also use a separate ready-made Wix checkout form where the visitor will be redirected from a non-Wix site or a custom ticket picker.
 * To build the checkout form path for this format, use Get Event to retrieve the `eventPageUrl.base` and `eventPageUrl.path`.
 * Then, add the following path: `/{{EVENT_PAGE_SLUG}}/{{SLUG}}/ticket-form?reservationId={{YOUR_RESERVATION_ID}}`
 *
 * Example:  `"https://johndoe.wixsite.com/weddings/event-details/doe-wedding/ticket-form?reservationId=2be6d34a-2a1e-459f-897b-b4a66e73f69a"`
 */
export function checkout(payload) {
    var _a = serializer(_checkoutRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_checkoutResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketDefinition: _ticketDefinition,
        _ticketReservation: _ticketReservation,
        _ticketSalePeriod: _ticketSalePeriod,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __checkout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.CheckoutService.Checkout',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __checkout.fromReq = fromReq;
    __checkout.__isAmbassador = true;
    return __checkout;
}
/**
 * Updates order and tickets.
 *
 * This method only supports orders with status set to `"INITIATED"`, `"PENDING"`, or `"OFFLINE_PENDING"`.
 *
 * Guest details updated here must match the registration form input fields.
 */
export function updateCheckout(payload) {
    var _a = serializer(_updateCheckoutRequest, {
        _address: _address,
        _addressLocation: _addressLocation,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guest: _guest,
        _inputValue: _inputValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCheckoutResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __updateCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketing.CheckoutService.UpdateCheckout',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/checkout/{orderNumber}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCheckout.fromReq = fromReq;
    __updateCheckout.__isAmbassador = true;
    return __updateCheckout;
}
/** Creates order with payment details already initiated via Cashier Pay API. */
export function posCheckout(payload) {
    var _a = serializer(_posCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_posCheckoutResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _checkIn: _checkIn,
        _formResponse: _formResponse,
        _formattedAddress: _formattedAddress,
        _guestDetails: _guestDetails,
        _inputValue: _inputValue,
        _order: _order,
        _paymentDetails: _paymentDetails,
        _paymentTransaction: _paymentTransaction,
        _ticketDefinition: _ticketDefinition,
        _ticketReservation: _ticketReservation,
        _ticketSalePeriod: _ticketSalePeriod,
        _ticketingTicket: _ticketingTicket,
    }).fromJSON;
    function __posCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.order',
            method: 'POST',
            methodFqn: 'wix.events.ticketing.CheckoutService.PosCheckout',
            url: resolveWixEventsTicketingCheckoutServiceUrl({
                protoPath: '/v1/pos-checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __posCheckout.fromReq = fromReq;
    __posCheckout.__isAmbassador = true;
    return __posCheckout;
}
//# sourceMappingURL=http.impl.js.map